import { Link } from "react-router-dom";
import type { Episode } from "@/utils/content";

export default function EpisodeCard({ episode }: { episode: Episode }) {
  return (
    <Link
      to={`/episode/${episode.id}`}
      className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-300"
    >
      <div className="relative h-40 w-full overflow-hidden bg-background-200 md:h-44">
        <img
          src={episode.cover}
          alt={`${episode.title} 剧集封面`}
          title={`火影忍者剧集 ${episode.number} ${episode.title}`}
          className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute left-3 top-3 rounded-md bg-primary-500 px-2 py-0.5 text-xs font-bold text-background-50">
          第 {episode.number} 集
        </span>
      </div>
      <div className="flex flex-1 flex-col p-4">
        <div className="flex items-center gap-2 text-xs text-foreground-500">
          <span className="rounded bg-secondary-100 px-2 py-0.5 text-secondary-700">
            {episode.arc}
          </span>
          <span>{episode.duration}</span>
        </div>
        <h3 className="mt-2.5 font-heading text-base font-bold text-foreground-950 transition-colors group-hover:text-primary-600">
          {episode.title}
        </h3>
        <p className="mt-2 line-clamp-2 text-sm leading-relaxed text-foreground-600">
          {episode.summary}
        </p>
      </div>
    </Link>
  );
}